import fetch from './fetch'
import qs from 'qs'

class RiskApi {
	public getList(form: any) {
		return fetch({
			url: 'bigdata/risk/queryRiskTaskList',
			method: 'post',
			data: form,
		})
	}

	public getDetail(reqId: any) {
		return fetch({
			url: 'bigdata/risk/queryRiskCaseDetail',
			method: 'post',
			params: {
				reqId,
			},
		})
	}
}

export default new RiskApi()
